import configureStore from "./configureStore.js"; //combined stores

export const store = configureStore();
